import { PropsWithChildren } from "react";

interface ReportInfoProps extends PropsWithChildren {
  hasData?: boolean;
  onClick?: () => void;
}

export function LogInfo({ onClick, children, hasData }: ReportInfoProps) {
  return (
    <div className="w-fit">
      {hasData ? (
        <div
          onClick={onClick}
          className={`border-[#DBDFE9] cursor-pointer font-semibold text-center flex flex-row items-center justify-center text-white text-3xs  bg-[#296573] border-[1px] rounded-[4px] h-[18px] w-[18px]`}
        >
          {children}
        </div>
      ) : (
        <div
          className={`border-[#DBDFE9]  border-[1px] rounded-[4px] h-[18px] w-[18px]`}
        ></div>
      )}
    </div>
  );
}
